import * as React from 'react';

import type { ToastNotification } from '../../types/toast-types';

import { ToastCard } from './toast-card';
import { ToastViewport } from './toast-viewport';
import { atPosition, TOAST_POSITIONS } from './toast-viewport-layout';

type ToastStacksProps = {
  notifications: ToastNotification[];
  onRemove: (id: string) => void;
};

/** Renders the toast store: one live region per position, each holding its own toasts. */
export const ToastStacks: React.FC<ToastStacksProps> = ({
  notifications,
  onRemove,
}) => (
  <>
    {TOAST_POSITIONS.map((position) => (
      <ToastViewport key={position} position={position}>
        {atPosition(notifications, position).map((n) => (
          <ToastCard key={n.id} notification={n} onRemove={onRemove} />
        ))}
      </ToastViewport>
    ))}
  </>
);

export default ToastStacks;
